// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

export interface VideoProps {
    src: string;
    autoPlay?: boolean;
    controls?: boolean;
    extension?: string;
}

type Props = VideoProps;

const Video: React.FC<Props> = ({ src, autoPlay, controls, extension }) => {
    if (!src) {
        return null;
    }

    return (
        <video width="100%" height="100%" controls={controls} autoPlay={autoPlay}>
            <source src={src} type={`video/${extension}`}></source>
        </video>
    );
};

export default Video;
